import { jsx as i } from "@emotion/react/jsx-runtime";
import { StyledContainer as d } from "./Notification.styled.js";
import { Icon as f } from "../Icon/index.js";
import { Tooltip as l } from "../Tooltip/index.js";
const s = {
  medium: "16px",
  small: "12px"
}, S = ({
  dataTrackId: m,
  className: e,
  variant: o = "notification",
  size: t = "medium",
  icon: r,
  text: n,
  tooltip: c,
  tooltipBaseId: p
}) => /* @__PURE__ */ i(l, { id: p, text: c, children: /* @__PURE__ */ i(d, { "data-track": m, variant: o, size: t, className: e, children: r ? /* @__PURE__ */ i(f, { icon: r, iconSize: s[t], color: o === "notification" ? "white" : o }) : n }) });
export {
  S as Notification
};
